import React, { Component } from 'react';
import { generalAuthTokenHeader } from '__helpers/auth-header';
import { apiPath } from 'api';
import logo from "../../../assets/img/MAXMRJ-Logo-1.png"

const INPUT_TYPE_MAP = {
  766001: 'Multiple Choice',
  766002: 'Checkbox',
  766003: 'Rating',
  766004: 'Paragraph'
};

class SurveyGeneralPreview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSurvey: true,
      loading: true,
      responses: {},
      surveyData: {},
      submitted: false,
      error: null
    };
  }

  handleInputChange = (questionId, value, isCheckbox = false) => {
    this.setState(prevState => {
      const updatedResponses = { ...prevState.responses };
      if (isCheckbox) {
        const existing = updatedResponses[questionId] || [];
        updatedResponses[questionId] = existing.includes(value)
          ? existing.filter(v => v !== value)
          : [...existing, value];
      } else {
        updatedResponses[questionId] = value;
      }
      return { responses: updatedResponses };
    });
  };

  handleRatingClick = (questionId, optionText) => {
    this.handleInputChange(questionId, optionText);
  };



  renderQuestion = (q, index) => {
    const { responses } = this.state;
    const questionId = q.questionId ?? `q_${index}`;
    const inputTypeName = q.inputTypeName || INPUT_TYPE_MAP[q.inputTypeId];
    const baseLabel = (
      <label style={{ fontWeight: 600 }}>
        {index + 1}. {q.questionText}
        {q.required && <span style={{ color: 'red' }}> *</span>}
        <span style={{ fontSize: '0.9rem', color: '#888' }}> (Weightage: {q.weightage})</span>
      </label>
    );

if (inputTypeName === 'Multiple Choice') {
  return (
    <div key={questionId} style={{ marginBottom: '1.5rem' }}>
      {baseLabel}
      {Array.isArray(q.options) && q.options.length > 0 ? (
        q.options.map((opt, i) => (
          <label key={i} style={{ display: 'block', marginTop: 4 }}>
            <input
              type="radio"
              name={`question_${questionId}`}
              value={opt.optionText}
              required={q.required}
              onChange={() => this.handleInputChange(questionId, opt.optionText)}
            />{' '}
            {opt.optionText}
          </label>
        ))
      ) : (
        <p style={{ color: 'gray' }}>No options available.</p>
      )}
    </div>
  );
}


  if (inputTypeName === 'Checkbox') {
  return (
    <div key={questionId} style={{ marginBottom: '1.5rem' }}>
      {baseLabel}
      {Array.isArray(q.options) && q.options.length > 0 ? (
        q.options.map((opt, i) => (
          <div key={i} style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
            <input
              type="checkbox"
              value={opt.optionText}
              onChange={() => this.handleInputChange(questionId, opt.optionText, true)}
            />
            <label style={{ marginLeft: 6 }}>{opt.optionText}</label>
          </div>
        ))
      ) : (
        <p style={{ color: 'gray' }}>No options available.</p>
      )}
    </div>
  );
}


if (q.inputTypeName === 'Rating') {
  const radios = q.options.map((opt) => (
    <label key={opt.optionId} style={{ marginRight: '10px', textAlign: 'center' }}>
      <input
        type="radio"
        name={`rating-${q.questionId}`}
        value={opt.optionText}
        checked={responses[q.questionId] === opt.optionText}
        onChange={() => this.handleRatingClick(q.questionId, opt.optionText)}
      />
      <div>{opt.optionText}</div>
    </label>
  ));

  return (
    <div key={questionId} style={{ marginBottom: '1.5rem' }}>
      {baseLabel}
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '8px' }}>
        <span>Poor</span>
        <div style={{ display: 'flex', gap: '10px' }}>{radios}</div>
        <span>Excellent</span>
      </div>
    </div>
  );
}


    // Paragraph or default to text input
    return (
      <div key={questionId} style={{ marginBottom: '1.5rem' }}>
        {baseLabel}
        <input
          type="text"
          required={q.required}
          onChange={e => this.handleInputChange(questionId, e.target.value)}
          style={{ width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #ccc' }}
        />
      </div>
    );
  };

  async componentDidMount() {
    const apiUrl = apiPath.GeneralPreviewSurvey;

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          ...generalAuthTokenHeader(),
          "Content-Type": "application/json",
        },
        body: JSON.stringify(this.props.payload),
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch survey preview: ${response.statusText}`);
      }

      const data = await response.json();
      console.log("data",data);
      
      this.setState({ surveyData: data, loading: false });
    } catch (error) {
      console.error("Error loading survey preview:", error);
      this.setState({ error: error.message, loading: false });
    }
  }

  render() {
    const { showSurvey, surveyData, submitted, loading, error } = this.state;

    if (loading) return <div>Loading survey...</div>;
    if (error) return <div style={{ color: 'red' }}>Error: {error}</div>;

    return (
      <div style={{ maxWidth: 700, margin: 'auto', backgroundColor: '#fff', padding: '2rem', borderRadius: 12 }}>
        <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
          <img src={logo} width="200" alt="MAX MRJ" />
        </div>

        {showSurvey && (
          <div>
            <h2 style={{ color: '#00A9A5' }}>{surveyData.title}</h2>
            <p>{surveyData.description}</p>
            <p>{surveyData.introText}</p>
            <form onSubmit={this.handleSurveySubmit}>
          {Array.isArray(surveyData.questions) &&
            surveyData.questions.map((q, i) => this.renderQuestion(q, i))}

             
            </form>
         
              <p style={{ marginTop: '2rem', fontWeight: 'bold', color: '#28a745' }}>{surveyData.endText}</p>
          
          </div>
        )}
      </div>
    );
  }
}

export default SurveyGeneralPreview;
